var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.searchedAppList &&
    _vm.searchedAppList.length > 0 &&
    _vm.isSearching == true
      ? _c(
          "div",
          { staticClass: "columns is-multiline page-integrations__cols" },
          _vm._l(_vm.searchedAppList, function(app) {
            return _c(
              "div",
              {
                key: app.id,
                staticClass: "app-card",
                attrs: { value: app.id }
              },
              [_c("app-card", { attrs: { app: app } })],
              1
            )
          })
        )
      : _vm.searchedAppList &&
        _vm.searchedAppList.length === 0 &&
        _vm.isSearching == true
      ? _c("div", [_c("btn-add-new-carrier")], 1)
      : _c("div", [
          _vm.selfServiceList && _vm.selfServiceList.length > 0
            ? _c(
                "div",
                { staticClass: "columns is-multiline page-integrations__cols" },
                _vm._l(_vm.selfServiceList, function(app) {
                  return _c(
                    "div",
                    {
                      key: app.id,
                      staticClass: "app-card",
                      attrs: { value: app.id }
                    },
                    [_c("app-card", { attrs: { app: app } })],
                    1
                  )
                })
              )
            : _c("div", { staticClass: "column" }, [_c("empty-app-list")], 1)
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-003891d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-003891d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/app-list/AppList.vue
// module id = null
// module chunks = 